module.exports = __webpack_public_path__ + "static/media/SQL.aa0b986b.JPG";